var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJobArea(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 27,
    height: 27,
    rx: 13.5,
    fill: "#F9FAFB"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 27,
    height: 27,
    rx: 13.5,
    stroke: "#EAECF0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.3333 15.6667V13.663C17.3333 13.5433 17.3333 13.4835 17.315 13.4307C17.2989 13.3839 17.2726 13.3414 17.2381 13.3061C17.199 13.2662 17.1455 13.2394 17.0384 13.1859L13.9999 11.6667M8.66659 12.3333V16.8711C8.66659 17.119 8.66659 17.243 8.70526 17.3515C8.73946 17.4475 8.79519 17.5343 8.86817 17.6054C8.95073 17.6858 9.06343 17.7374 9.28882 17.8408L13.5555 19.7963C13.719 19.8712 13.8007 19.9087 13.8859 19.9235C13.9613 19.9366 14.0385 19.9366 14.114 19.9235C14.1991 19.9087 14.2809 19.8712 14.4444 19.7963L18.711 17.8408C18.9364 17.7374 19.0491 17.6858 19.1317 17.6054C19.2047 17.5343 19.2604 17.4475 19.2946 17.3515C19.3333 17.243 19.3333 17.119 19.3333 16.8711V12.3333M7.33325 11.6667L13.7614 8.45259C13.8489 8.40887 13.8926 8.387 13.9385 8.3784C13.9791 8.37078 14.0208 8.37078 14.0614 8.3784C14.1073 8.387 14.151 8.40887 14.2384 8.45259L20.6666 11.6667L14.2384 14.8807C14.151 14.9245 14.1073 14.9463 14.0614 14.9549C14.0208 14.9626 13.9791 14.9626 13.9385 14.9549C13.8926 14.9463 13.8489 14.9245 13.7614 14.8807L7.33325 11.6667Z",
    stroke: "#667085",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJobArea);
export default __webpack_public_path__ + "static/media/job-area.8bb6a252bcd9cabb0b3af4541093967e.svg";
export { ForwardRef as ReactComponent };